const Camera = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 48 48"
		fill="none"
		{...props}
	>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={4}
			d="M13.654 12.35a4.62 4.62 0 0 1-3.282 2.11c-.76.108-1.514.224-2.268.35-2.106.35-3.604 2.204-3.604 4.338V36A4.5 4.5 0 0 0 9 40.5h30a4.5 4.5 0 0 0 4.5-4.5V19.148c0-2.134-1.5-3.988-3.604-4.338a95.85 95.85 0 0 0-2.268-.35 4.62 4.62 0 0 1-3.28-2.11l-1.644-2.632a4.384 4.384 0 0 0-3.472-2.078 97.55 97.55 0 0 0-10.464 0 4.384 4.384 0 0 0-3.472 2.078l-1.642 2.632Z"
		/>
		<path
			stroke="#000"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={4}
			d="M33 25.5a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm4.5-4.5h.016v.016H37.5V21Z"
		/>
	</svg>
);
export default Camera;
